<template>
  <span>{{formattedMinutes}}:{{formattedSeconds}}</span>
</template>
<script>
  export default {
    props: {
      time: Number
    },
    computed: {
      formattedMinutes: function(){
        let minutes = Math.trunc(this.time/60)
        return minutes.toString().padStart(2, '0');
      },
      formattedSeconds: function(){
        let seconds = this.time%60
        return seconds.toString().padStart(2, '0');
      },
    }
  }
</script>
